/** Paths to array fields in the content type schema, including nested objects. */
export function getArrayKeyPaths(schema: any): string[] {
  const paths = new Set<string>();

  const visit = (nodes: any[], parent = ''): void => {
    if (!Array.isArray(nodes)) return;

    for (const node of nodes) {
      if (!node?.key) continue;
      const path = parent ? `${parent}.${node.key}` : node.key;
      if (node.type === 'array') paths.add(path);
      visit(node.type === 'array' ? node.items?.properties : node.properties, path);
    }
  };

  visit(Array.isArray(schema) ? schema : schema?.properties);
  // Buttons and images need one object per list entry so that their template
  // can reference fields such as `${title}` or `${url}`. Primitive lists are
  // therefore not offered in these pickers.
  return [...paths].filter(path => getArrayItemKeyPaths(schema, path).length > 0);
}

export function displayArrayKeyPath(path: string): string {
  const lastSeparator = path.lastIndexOf('.');
  return lastSeparator < 0 ? path : `…${path.slice(lastSeparator + 1)}`;
}

/** Leaf field paths available on one object inside the selected array. */
export function getArrayItemKeyPaths(schema: any, arrayPath: string | undefined | null): string[] {
  const segments = String(arrayPath || '').split('.').filter(Boolean);
  let nodes = Array.isArray(schema) ? schema : schema?.properties;
  let arrayNode: any;

  for (const segment of segments) {
    const node = Array.isArray(nodes) ? nodes.find((candidate: any) => candidate?.key === segment) : undefined;
    if (!node) return [];
    arrayNode = node;
    nodes = node.type === 'array' ? node.items?.properties : node.properties;
  }

  if (arrayNode?.type !== 'array' || !Array.isArray(arrayNode.items?.properties)) return [];
  const paths: string[] = [];
  const visit = (children: any[], parent = ''): void => {
    children.forEach((node: any) => {
      if (!node?.key) return;
      const path = parent ? `${parent}.${node.key}` : node.key;
      if (node.type === 'object') visit(node.properties || [], path);
      else paths.push(path);
    });
  };

  visit(arrayNode.items.properties);
  return paths;
}
